/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const scissors_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M23 4 2.5 16.627m0 0a3.5 3.5 0 1 0 4 5.745 3.5 3.5 0 0 0-4-5.745ZM23 20 2.5 7.373m0 0a3.5 3.5 0 1 0 4-5.745 3.5 3.5 0 0 0-4 5.745Z"
    />
  </svg>
)
export default scissors_medium
